import { type ReactNode, useId } from "react";

interface SettingsSectionProps {
  /** The section's title, its `<h2>` under the Settings page's `<h1>`. */
  title: string;
  /** One line under the title. */
  description?: ReactNode;
  /** Controls right of the title. */
  actions?: ReactNode;
  children: ReactNode;
}

/** One section of the Settings area (Account, Logboek, …): its title and its content. */
export function SettingsSection({ title, description, actions, children }: SettingsSectionProps) {
  const headingId = useId();
  return (
    <section aria-labelledby={headingId}>
      <header className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <div className="min-w-0">
          <h2 id={headingId} className="font-heading text-primary text-xl font-bold">
            {title}
          </h2>
          {description && <p className="text-muted mt-1 text-sm">{description}</p>}
        </div>
        {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
      </header>
      {children}
    </section>
  );
}
